module.exports = __webpack_public_path__ + "img/MapThumb_BanditCanyon.4c2cf139.webp";